import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { catalogBibShape, bibShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectPremiumSuggestionsSummary } from 'app/selectors/bibs/UserTransactionsSelector';
import PremiumSuggestionButton from './PremiumSuggestionButton';

export function PremiumSuggestionButtonContainer(props) {
  return <PremiumSuggestionButton {...props} />;
}

PremiumSuggestionButtonContainer.propTypes = {
  bib: bibShape.isRequired,
  catalogBib: catalogBibShape.isRequired,
  currentLibrary: libraryShape.isRequired,
  premiumSuggestionsSummary: ImmutablePropTypes.map.isRequired
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  const metadataId = catalogBib.get('metadataId');
  const bib = selectBibEntities(state).get(metadataId);

  return {
    bib,
    catalogBib,
    currentLibrary: selectCurrentLibrary(state),
    premiumSuggestionsSummary: selectPremiumSuggestionsSummary(state)
  };
};

export default connect(mapStateToProps)(PremiumSuggestionButtonContainer);
